import api from './api'

export const eventsService = {
  // Get all events
  async getEvents() {
    const response = await api.get('/events')
    return response // api.js already returns response.data
  },

  // Create new event
  async createEvent(eventData) {
    const response = await api.post('/events', eventData)
    return response // api.js already returns response.data
  },

  // Update event
  async updateEvent(eventId, eventData) {
    const response = await api.put(`/events/${eventId}`, eventData)
    return response // api.js already returns response.data
  },

  // Delete event
  async deleteEvent(eventId) {
    const response = await api.delete(`/events/${eventId}`)
    return response // api.js already returns response.data
  },

  // Get AI event suggestions
  async getEventSuggestions(prompt, context = '') {
    const response = await api.post('/events/suggest', {
      prompt,
      context
    })
    return response // api.js already returns response.data
  },

  // Get smart scheduling recommendations
  async getSmartScheduling(eventTitle, preferredTimeframe = '', constraints = '') {
    const response = await api.post('/events/smart-schedule', {
      eventTitle,
      preferredTimeframe,
      constraints
    })
    return response // api.js already returns response.data
  }
}

export default eventsService